/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: 83a97ed01c76
 */

import * as z from "zod";

export type FolderNamePath = { name: string; path: string };

export const FolderNamePath$zodSchema: z.ZodType<FolderNamePath> = z.object({
  name: z.string().describe("The name of the folder."),
  path: z.string().describe("The full path of the folder."),
});
